<template>
  <div id="login" class="min-h-screen flex items-start justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full">
      <cibus-icon title="Cibus" class="mb-8"></cibus-icon>

      <div class="flex flex-col items-center">
        <card-login-register />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonLG from "@/components/ButtonLG"
import CibusIcon from '@/components/CibusIcon.vue'
import CardLoginRegister from '@/components/AuthCards/CardLoginRegister.vue'

export default {
  components: {
    'button-lg': ButtonLG,
    'cibus-icon': CibusIcon,
    'card-login-register': CardLoginRegister,
  }
}
</script>

<style scoped>
#login {
  background: linear-gradient(180deg, #A6E28B 33.44%, #78C5CA 100%);
}
</style>